import columnTypes from '../columnTypes.js';
import types from '../types.js';

const processSchedulerTables = [
  {
    key: 'scanned-assets',
    name: 'Recently Scanned Assets',
    [columnTypes.default.key]: [
      {
        source: 'AssetName',
        rename: 'Asset',
        type: types.text,
      },
      {
        source: 'ScheduledDate',
        rename: 'Scheduled Date (UTC)',
        type: types.text,
      },
      {
        source: 'StartDate',
        rename: 'Start Date (UTC)',
        type: types.text,
      },
      {
        source: 'EndDate',
        rename: 'End Date (UTC)',
        type: types.text,
      },
      {
        source: 'Runtime',
        rename: 'Run Time',
        type: types.text,
      },
      {
        source: 'NextRunDate',
        rename: 'Next Run Date (UTC)',
        type: types.text,
      },
      {
        source: 'Status',
        rename: 'Status',
        type: types.text,
      },
      {
        source: 'Connector',
        rename: 'Connector',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'NextRun',
        rename: 'Next Run',
        type: types.text,
      },
      {
        source: 'SatelliteServerName',
        rename: 'Scan Server Name',
        type: types.text,
      },
      {
        source: 'TaskName',
        rename: 'Task Name',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: 'ID',
        rename: 'ID',
      },
      {
        source: 'Type',
        rename: 'Type',
        type: types.text,
      },
      {
        source: 'Name',
        rename: 'Name',
        type: types.text,
      },
      {
        source: 'keySwitch',
        rename: 'Key Switch',
        type: types.text,
      },
      {
        source: 'keyType',
        rename: 'Key Type',
        type: types.text,
      },
      {
        source: 'Configuration',
        rename: 'Configuration',
        type: types.text,
      },
    ],
  },
  {
    key: 'assets-all',
    name: 'All Assets',
    [columnTypes.default.key]: [
      {
        source: 'AssetName',
        rename: 'Asset',
        type: types.text,
      },
      {
        source: 'Configuration',
        rename: 'Configuration',
        type: types.text,
      },
      {
        source: 'Type',
        rename: 'Type',
        type: types.text,
      },
      {
        source: 'ScheduledDate',
        rename: 'Scheduled Date',
        type: types.text,
      },
      {
        source: 'StartDate',
        rename: 'Start Date',
        type: types.text,
      },
      {
        source: 'EndDate',
        rename: 'End Date',
        type: types.text,
      },
      {
        source: 'Runtime',
        rename: 'Run Time',
        type: types.text,
      },
      {
        source: 'NextRunDate',
        rename: 'Next Run Date',
        type: types.text,
      },
      {
        source: 'Status',
        rename: 'Status',
        type: types.text,
      },
      {
        source: 'Connector',
        rename: 'Connector',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'NextRun',
        rename: 'Next Run Date',
        type: types.text,
      },
      {
        source: 'SatelliteServerName',
        rename: 'Scan Server Name',
        type: types.text,
      },
      {
        source: 'TaskName',
        rename: 'Task Name',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: 'ID',
        rename: 'ID',
      },
      {
        source: 'Name',
        rename: 'Name',
        type: types.text,
      },
      {
        source: 'keySwitch',
        rename: 'Key Switch',
        type: types.text,
      },
      {
        source: 'keyType',
        rename: 'Key Type',
        type: types.text,
      },
      {
        source: 'ShowTarget',
        rename: 'Show Target',
      },
      {
        source: 'ShowPercent',
        rename: 'Show Percent',
      },
    ],
  },
  {
    key: 'task-log-details',
    name: 'Task Log Details',
    [columnTypes.default.key]: [
      {
        source: 'TargetCount',
        rename: 'Target Count',
        type: types.text,
      },
      {
        source: 'TaskName',
        rename: 'Task Name',
        type: types.text,
      },
      {
        source: 'Configuration',
        rename: 'Configuration Name',
        type: types.text,
      },
      {
        source: 'Connector',
        rename: 'Task Type',
        type: types.text,
      },
      {
        source: 'SucceededTargets',
        rename: 'Targets Succeeded',
      },
      {
        source: 'WarningTargets',
        rename: 'Targets Succeeded with Warnings',
      },
      {
        source: 'FailedTargets',
        rename: 'Targets Failed',
      },
      {
        source: 'EndDate',
        rename: 'End Date (UTC)',
        type: types.date,
      },
      {
        source: 'ScheduledDate',
        rename: 'Scheduled Date (UTC)',
        type: types.date,
      },
      {
        source: 'Status',
        rename: 'Status',
        type: types.text,
      },
      {
        source: 'PriorityTask',
        rename: 'Priority Task',
        type: types.boolean,
      },
      {
        source: 'Runtime',
        rename: 'Run Time (Scan/Ingestion)',
        type: types.text,
      },
      {
        source: 'RecurringPeriod',
        rename: 'Recurring Period',
        type: types.text,
      },
      {
        source: 'SatelliteServer',
        rename: 'Scan Server',
        type: types.text,
      },
      {
        source: 'Percentage',
        rename: 'Percent Complete',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'TaskID',
        rename: 'Task ID',
        type: types.text,
      },
      {
        source: 'RecurringPeriod',
        rename: 'Recurring Period',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: 'ID',
      },
      {
        source: 'TaskHistoryID',
      },
      {
        source: 'selectable',
      },
      {
        source: 'noSelectMessage',
      },
      {
        source: 'TaskEngineID',
      },
      {
        source: 'Configuration',
      },
    ],
  },
];
export default [...processSchedulerTables];
